<template>
  <v-container>
    <v-container class="d-flex justify-space-between align-center">
      최종 갱신: {{ lastUpdate }}
      <v-spacer></v-spacer>
      <v-btn icon @click="fetch"><v-icon>mdi-refresh</v-icon></v-btn>
    </v-container>

    <v-card v-if="adminDashboard" class="mb-4">
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="4" v-if="$store.state.user._cps.length > 1">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">전체 가동률</span>
              </div>
              <div class="grey--text text--darken-1 pb-2">
                <span v-text="devicesTotal"></span>대 중
                <span v-text="daysTotal"></span>대
                ({{ totalOperationRate }} %)</div>
              <div>
                <v-progress-linear height="10" :value="totalOperationRate"></v-progress-linear>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">공회전율</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>공회전시간 / 주행시간 * 100</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1 pb-2">{{ idleRate }} %</div>
              <div>
                <v-progress-linear :color="progressColor(idleRate)" height="10" :value="idleRate"></v-progress-linear>
              </div>
            </div>
          </v-col> -->
          <!-- <v-col cols="12" sm="4">
            <div>
              <div class="title">공회전 시간</div>
              <div class="grey--text text--darken-1">{{ totalIdleTime }} 시간</div>
            </div>
          </v-col> -->
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">전체 공회전 정지율</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <!-- <span>(공회전 정지 시간 / (구역내 공회전 시간 + 공회전 정지 시간)) * 100</span> -->
                  <span>공회전 정지란? 지정된 구역 내에서 장치에 의해 공회전이 제한되는것.</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1 pb-2">{{ totalIdleStopRate }} %</div>
              <div>
                <v-progress-linear :color="progressColor(totalIdleStopRate)" height="10" :value="totalIdleStopRate"></v-progress-linear>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="title">전체 공회전 정지 시간</div>
              <div class="grey--text text--darken-1">{{ (adminDashboard.SumOfIdleStopTime / 60 / 60).toFixed(2) }} 시간</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="title">전체 공회전 정지 횟수</div>
              <div class="grey--text text--darken-1">{{ adminDashboard.SumOfIdleStopCount }} 회</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">전체 평균 연비</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>단위 연료당 (ℓ or ㎥)</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1">{{ (adminDashboard.SumOfTrip / adminDashboard.SumOfFuel).toFixed(2) }} Km</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">전체 초 미세먼지(pm2.5) 저감량</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>공회전정지시간 * 연료별 상수</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1">약 {{ adminDashboard.SumOfDustReduced.toFixed(2) }} g</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">전체 안전운전 평균 점수</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>운행거리 100km 당, 급제동, 급가속, 급회전 등의 횟수를 기반으로 산출</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1">{{ adminDashboard.AverageSmartScore.toFixed(2) }} 점</div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card>
      <v-container fluid>
        <v-row>
          <!-- <v-col cols="12" md="4" v-if="$store.state.user._cps.length > 1">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">전체 가동률</span>
              </div>
              <div class="grey--text text--darken-1 pb-2">
                <span v-text="devicesTotal"></span>대 중
                <span v-text="daysTotal"></span>대
                ({{ totalOperationRate }} %)</div>
              <div>
                <v-progress-linear height="10" :value="totalOperationRate"></v-progress-linear>
              </div>
            </div>
          </v-col> -->
          <v-col cols="12" md="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">회사 가동률</span>
              </div>
              <div class="grey--text text--darken-1 pb-2">
                <span v-text="devices.length"></span>대 중
                <span v-text="days.length"></span>대
                ({{ operationRate }} %)</div>
              <div>
                <v-progress-linear height="10" :value="operationRate"></v-progress-linear>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">공회전율</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>공회전시간 / 주행시간 * 100</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1 pb-2">{{ idleRate }} %</div>
              <div>
                <v-progress-linear :color="progressColor(idleRate)" height="10" :value="idleRate"></v-progress-linear>
              </div>
            </div>
          </v-col> -->
          <!-- <v-col cols="12" sm="4">
            <div>
              <div class="title">공회전 시간</div>
              <div class="grey--text text--darken-1">{{ totalIdleTime }} 시간</div>
            </div>
          </v-col> -->
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">공회전 정지율</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <!-- <span>(공회전 정지 시간 / (구역내 공회전 시간 + 공회전 정지 시간)) * 100</span> -->
                  <span>공회전 정지란? 지정된 구역 내에서 장치에 의해 공회전이 제한되는것.</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1 pb-2">{{ idleStopRate }} %</div>
              <div>
                <v-progress-linear :color="progressColor(idleStopRate)" height="10" :value="idleStopRate"></v-progress-linear>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="title">공회전 정지 시간</div>
              <div class="grey--text text--darken-1">{{ totalIdleStopTime }} 시간</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="title">공회전 정지 횟수</div>
              <div class="grey--text text--darken-1">{{ totalIdleCount }} 회</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">평균 연비</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>단위 연료당 (ℓ or ㎥)</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1">{{ fuelRate }} Km</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">초 미세먼지(pm2.5) 저감량</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>공회전정지시간 * 연료별 상수</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1">약 {{ dustReduced }} g</div>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div>
              <div class="d-flex align-center">
                <span class="title pr-1">안전운전 평균 점수</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-information</v-icon>
                  </template>
                  <span>운행거리 100km 당, 급제동, 급가속, 급회전 등의 횟수를 기반으로 산출</span>
                </v-tooltip>
              </div>
              <div class="grey--text text--darken-1">{{ smartScore }} 점</div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-container>
      <span class="title">자주 찾는 메뉴</span>
      <v-row>
        <v-col cols="12" sm="6">
          <v-btn block color="info" :to="{ name: 'settings-devices' }">공회전 ON/OFF 관리</v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <v-btn block color="info" :to="{ name : 'history-non-receipt' }">미수신 차량 확인</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :items="groupedItems"
            :headers="headers"
            :sort-by.sync="sortBy"
            :sort-desc.sync="descending"
            class="text-no-wrap"
          >
            <template v-slot:top>
              <span class="title">노선별 평균</span>
            </template>
            <template v-slot:item.fuelType="{ item }">
              <fueltype-chip :fueltype="item.fuelType"></fueltype-chip>
            </template>
            <template v-slot:item.fuelEfficiency="{ item }">
              {{ item.fuelEfficiency === Infinity ? (0).toFixed(2) : item.fuelEfficiency.toFixed(2) }}
            </template>
            <template v-slot:item.idleStopRate="{ item }">
              {{ item.idleStopRate.toFixed(2) }}
            </template>
            <template v-slot:item.smartScore="{ item }">
              {{ item.smartScore.toFixed(2) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <idle-rate-of-groups></idle-rate-of-groups>

    <!-- <v-dialog fullscreen v-model="dialog" hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="pink"
          dark
          fixed
          bottom
          right
          fab>
            <v-icon>mdi-chat-processing</v-icon>
          </v-btn>
      </template>

      <v-card class="fill-height">
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>
            간편 문의
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="height: calc(100vh - 48px)">
          <qna-messages/>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import { getDayList, getDeviceList, getDevicesCount, getDaysCount, getAdminDashboard } from '@/api'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'
import sumBy from 'lodash/sumBy'

import idleRateOfGroups from './charts/idle-rate-of-groups'
import qnaMessages from './qna-messages'

export default {
  components: {
    qnaMessages,
    idleRateOfGroups
  },
  data () {
    return {
      devicesTotal: 0,
      daysTotal: 0,
      dialog: false,
      days: [],
      devices: [],
      updatedAt: new Date(),
      sortBy: 'fuelEfficiency',
      descending: true,
      adminDashboard: null,
      headers: [
        {
          text: '노선',
          value: 'group.name'
        },
        {
          text: '유종',
          value: 'fuelType'
        },
        {
          text: '차량대수 (대)',
          value: 'count'
        },
        {
          text: '연비 (Km)',
          value: 'fuelEfficiency'
        },
        {
          text: '공회전 정지율 (%)',
          value: 'idleStopRate'
        },
        {
          text: '안전운전 점수 (점)',
          value: 'smartScore'
        }
      ]
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    operationRate () {
      const devices = this.devices.length
      const days = this.days.length

      if (!days) return 0
      else if (!devices) return 0
      else return (days / devices * 100).toFixed(2)
    },
    totalOperationRate () {
      const devices = this.devicesTotal
      const days = this.daysTotal

      if (!days) return 0
      else if (!devices) return 0
      else return (days / devices * 100).toFixed(2)
    },
    groupedItems () {
      const items = this.days.map(day => {
        const group = {
          _id: get(day, '_dv.group._id', null),
          name: get(day, '_dv.group.name', '미지정')
        }
        const plateNo = get(day, '_dv.info.plateNo')
        const fuelType = ({
          0: '미지정',
          1: '경유',
          2: 'CNG'
        })[get(day, '_dv.fuelType', 0)]
        const date = this.$moment(get(day, 'ymd'), 'YYMMDD').format('YYYY. MM. DD.')
        const trip = get(day, 'dTrip', 0)
        const fuel = get(day, 'dFuel', 0)
        const fuelEfficiency = (trip / fuel || 0)
        const idleTime = get(day, 'dIdleTime', 0)
        const runTime = get(day, 'dLap', 0)
        const idleRate = (idleTime / runTime * 100 || 0)
        const idleStopTime = get(day, 'dIdleStopTime', 0)
        const idleGpsPtsTime = get(day, 'dIdleGpsPtsTime', 0)
        const idleStopRate = (idleStopTime / (idleStopTime + idleGpsPtsTime) * 100 || 0)
        const fuelReduced = get(day, 'dIdleStopFuel', 0)
        const idleStopCount = get(day, 'dIdleStopCnt', 0)
        const smartScore = get(day, 'smartScore.total', 0)

        return {
          group,
          plateNo,
          fuelType,
          date,
          trip,
          fuelEfficiency,
          runTime,
          idleRate,
          idleStopRate,
          fuelReduced,
          idleStopCount,
          smartScore
        }
      })

      const grouped = groupBy(items, (item) => {
        return [item.group._id, '|', item.fuelType].join('')
      })

      const result = Object.entries(grouped).reduce((items, [key, days]) => {
        const daysForScore = days.filter(day => {
          // return day.trip >= 100
          return true
        })
        items.push({
          group: days[0].group,
          fuelType: days[0].fuelType,
          count: days.length,
          fuelEfficiency: sumBy(days, 'fuelEfficiency') / days.length,
          idleRate: sumBy(days, 'idleRate') / days.length,
          idleStopRate: sumBy(days, 'idleStopRate') / days.length,
          smartScore: (sumBy(daysForScore, 'smartScore') / daysForScore.length) || 100
        })

        return items
      }, [])

      return result
    },
    lastUpdate () {
      return this.updatedAt.toLocaleString()
    },
    totalIdleStopRate () {
      if (!this.adminDashboard) return 0

      const idleStop = this.adminDashboard.SumOfIdleStopTime
      const gpsTime = this.adminDashboard.SumOfGpsPtsTime

      const result = (idleStop / (gpsTime + idleStop)) * 100 || 0

      return result.toFixed(2)
    },
    idleStopRate () {
      let idleStop = 0
      let gpsTime = 0

      this.days.forEach(({ dIdleStopTime, dIdleGpsPtsTime }) => {
        idleStop += dIdleStopTime
        gpsTime += dIdleGpsPtsTime
      })

      const result = (idleStop / (gpsTime + idleStop)) * 100 || 0

      return result.toFixed(2)
    },
    idleRate () {
      let idle = 0
      let lap = 0

      this.days.forEach(({ dLap, dIdleTime }) => {
        idle += dIdleTime
        lap += dLap
      })

      const result = idle / lap * 100 || 0

      return result.toFixed(2)
    },
    totalIdleStopTime () {
      const time = this.days.reduce((total, day) => {
        return total + day.dIdleStopTime
      }, 0)

      const hour = time / 60 / 60

      return hour.toFixed(2)
    },
    totalIdleTime () {
      const time = this.days.reduce((total, day) => {
        return total + day.dIdleTime
      }, 0)

      const hour = time / 60 / 60

      return hour.toFixed(2)
    },
    totalIdleCount () {
      return this.days.reduce((total, day) => {
        return total + day.dIdleStopCnt
      }, 0)
    },
    fuelRate () {
      let fuel = 0
      let trip = 0

      this.days.forEach(({ dFuel, dTrip }) => {
        fuel += dFuel
        trip += dTrip
      })

      const result = trip / fuel || 0

      return result.toFixed(2)
    },
    dustReduced () {
      const constants = {
        '미지정': 0,
        '경유': 0.00332,
        'CNG': 0.00117
      }

      const result = this.days.reduce((total, day) => {
        const fuelType = get(day, '_dv.fuelType', 0)
        const symbol = {
          0: '미지정',
          1: '경유',
          2: 'CNG'
        }

        const key = symbol[fuelType]

        return total + constants[key] * day.dIdleStopTime
      }, 0)

      return result.toFixed(2)
    },
    smartScore () {
      let count = 0
      const total = this.days.reduce((total, day) => {
        if (!day.hasOwnProperty('smartScore')) return total
        if (day.dTrip < 100) return total

        const score = day.smartScore.total

        // if (score === 100) return total

        count++
        return total + score
      }, 0)

      const result = total / count || 100

      return result.toFixed(2)
    }
  },
  methods: {
    progressColor (value) {
      if (value < 20) return 'success'
      else if (value < 40) return 'primary'
      else if (value < 60) return 'warning'
      else return 'error'
    },
    fetch () {
      this.fetchTodayDays()
      this.fetchDevices()
      this.fetchOperationRate()
      this.fetchAdminDashboard()
    },
    async fetchAdminDashboard () {
      if (!this.$store.state.user.isAdmin && this.$store.state.user._cps.length < 2) return

      try {
        this.adminDashboard = await getAdminDashboard()
      } catch (err) {
        console.error(err)
      }
    },
    async fetchOperationRate () {
      try {
        const devicesTotal = await getDevicesCount()
        const daysTotal = await getDaysCount()

        this.devicesTotal = devicesTotal
        this.daysTotal = daysTotal
      } catch (err) {
        console.error(err)
      }
    },
    async fetchDevices () {
      try {
        const query = {
          fields: '_id'
        }

        const { devices } = await getDeviceList({}, query)
        this.devices = devices
      } catch (err) {
        console.error(err)
      }
    },
    async fetchTodayDays () {
      try {
        const filters = {
          date: this.$moment().format('YYYY-MM-DD')
        }

        const query = {
          fields: 'dFuel dTrip smartScore.total dIdleStopTime dLap dIdleTime dIdleStopCnt dIdleGpsPtsTime',
          populate: '_dv'
        }

        const { days } = await getDayList(filters, query)
        this.days = days

        this.updatedAt = new Date()
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
